import { captureForTest } from "./trackingTestCapture";

// GA4 event wrapper via gtag.js. Safe to call before gtag.js has loaded —
// the stub in index.html queues calls into window.dataLayer and gtag.js
// replays them on init. If VITE_GA4_MEASUREMENT_ID is empty, the GA4
// destination is never configured and these events are accepted but
// dropped by gtag.js (no network calls).

export type GA4SignUpMethod = "email" | "google" | "apple" | "facebook";

export type GA4Item = {
  item_id: string;
  item_name: string;
  price: number;
  quantity: number;
};

export type GA4PurchasePayload = {
  transaction_id: string;
  value: number;
  currency: string;
  items: Array<GA4Item>;
};

export type GA4PageViewPayload = {
  page_location: string;
  page_title: string;
  page_path: string;
};

const event = (name: string, params: Record<string, unknown>) => {
  captureForTest("ga4", name, params);

  if (typeof window === "undefined" || typeof window.gtag !== "function")
    return;
  window.gtag("event", name, params);
};

export const trackSignUp = (method: GA4SignUpMethod) =>
  event("sign_up", { method });

export const trackPurchase = (payload: GA4PurchasePayload) =>
  event("purchase", payload as unknown as Record<string, unknown>);

export const trackPageView = (payload: GA4PageViewPayload) =>
  event("page_view", payload as unknown as Record<string, unknown>);
